const ENVIRONMENTS_PREFIX = 'Module.Environment';

export const ENVIRONMENT_FEATURES = {
  module: `${ENVIRONMENTS_PREFIX}`,
};
